import React, { ChangeEvent, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { CategoryList } from '~/Components/Icons/CategoryList';
import { useLanguage } from '~/Hooks';
import { SportCategory } from '~/Models/DTO/SportCatogories.model';
import { requestSportCategories, selectSportCategoryTypeList } from '~/store/events';
import { ModalSelectRadioGroupList } from '~/UIKit/Form/ModalSelect/listTypes';
import { ModalSelectPopover } from './ModalSelectPopover';
import { IModalProps } from './types';
import { useSportCatgeroy } from '~/Helpers/SportCategory';

export const ModalSelectSportCategoryPopover = memo(
  ({ open, name, onClose, anchorEl, selected, setFieldValue }: IModalProps<number>) => {
    const { t } = useLanguage();
    const { getCategory } = useSportCatgeroy();
    const dispatch = useDispatch();
    const getSportCategories = bindActionCreators(requestSportCategories, dispatch);
    const [searchQuery, setSearchQuery] = useState('');
    const sportCategories = useSelector(selectSportCategoryTypeList);
    const filteredSportCategories = sportCategories
      .map(({ id }) => ({
        id,
        name: getCategory(id),
        icon: <CategoryList />,
      }))
      .filter(
        ({ name, id }) => id === selected || name.toLowerCase().includes(searchQuery.toLowerCase()),
      );

    const handleSelect = (sportCategory: SportCategory) => {
      setFieldValue(name, sportCategory.id);
      onClose();
    };

    useEffect(() => {
      if (!sportCategories.length) {
        getSportCategories();
      }
    }, []);

    const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
      setSearchQuery(event.currentTarget.value);
    };

    return (
      <ModalSelectPopover
        open={open}
        title={t('app.event.categories')}
        onClose={onClose}
        anchorEl={anchorEl}
        actionName={t('app.checkin.select.done')}
        onActionTaken={onClose}
        search={{
          id: 'searchSportCategoryTypes',
          value: searchQuery,
          placeholder: t('app.event.changeEventCategoryType.searchForNewEventCategoryType'),
          handleSearch,
          withBackground: true,
        }}
      >
        <ModalSelectRadioGroupList
          list={filteredSportCategories}
          onSelect={handleSelect}
          selectedId={selected}
        />
      </ModalSelectPopover>
    );
  },
);
